import { useEffect } from "react";
import { compose } from "redux";
import { dashboardConnector } from "../../../../services/menu/dashboard/connector";

const DashboardComponent = ({ children, fetchDashboardLoanData }) => {
  useEffect(() => {
    fetchDashboardLoanData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let wrapperStyle = {
    display: "flex",
    minHeight: "100%",
  };

  return (
    <div style={wrapperStyle}>
      <div
        style={{
          width: "100%",
          boxSizing: "border-box",
          overflow: "auto",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default compose(dashboardConnector)(DashboardComponent);
